import React from "react"
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Breadcrumbs,
  BreadcrumbItem,
  Button,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css

export default function MainContainer({
  children,
  pageName="",
  info=[],
  breadcrumbs = [],
  prevPage = {},
}) {
  return (
    <Card className="rounded-none min-h-screen lg:ml-64 relative">
      <ToastContainer />
      <CardHeader className="flex flex-col gap-2 items-start sticky">
        <div className="flex items-center justify-between w-full  ">
          {/* breadcrumbs */}
          {breadcrumbs?.length > 0 && (
            <Breadcrumbs variant={"solid"} className="text-sm">
              {breadcrumbs?.map((item) => {
                return (
                  <BreadcrumbItem className="text-xs" key={item}>
                    {item}
                  </BreadcrumbItem>
                )
              })}
            </Breadcrumbs>
          )}
          {/* end of breadcrumbs */}
          {prevPage && prevPage?.show && (
            <Button
              size="sm"
              color="primary"
              variant="shadow"
              className="text-xs"
              startContent={<FontAwesomeIcon icon={faChevronLeft} />}
              onClick={prevPage?.onClick}
            >
              Back
            </Button>
          )}
        </div>
        <div>
          {/* page heading */}
          <div>
            <p className="text-md">{pageName}</p>
          </div>
          <div className=" text-gray-400 font-semibold">
            {info.map((infoItem, index) => {
              return (
                <div key={index} className="flex flex-row gap-2">
                  {infoItem.map((item, index) => {
                    return (
                      <p
                        key={index}
                        size="sm"
                        className={`rounded-none text-xs`}
                      >
                        {item}
                      </p>
                    )
                  })}
                </div>
              )
            })}
          </div>
          {/* end of page heading */}
        </div>
      </CardHeader>
      <CardBody>{children}</CardBody>
      <CardFooter></CardFooter>
    </Card>
  )
}
